<template>
  <a-modal :visible="visible"
           @cancel="$emit('cancel')"
           :destroyOnClose="true"
           :width="1000"
           :confirmLoading="modalLoading"
           :maskClosable="false" :title="getTitle" @ok="onSave">
    <a-form-model
        ref="form"
        :model="unitData"
        :rules="rules"
        class="exi_form item_100"  :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }">
      <a-row :gutter="80">
        <a-col :span="24">
          <a-form-model-item label="单位名称" prop="unitName">
            <a-input v-model.trim="unitData.unitName" placeholder="单位名称"/>
          </a-form-model-item>
        </a-col>

        <a-col :span="24">
          <a-form-model-item label="信用代码">
            <a-input v-model.trim="unitData.creditCode" placeholder="信用代码"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { AddUnit, EditUnit, GetUnit } from './api/UnitRequest'

const rules = {
  unitName: [{ required: true, message: '请输入单位名称', trigger: 'change' }],
}
export default {
  name: 'AddOrEditUnitModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  components: {},
  data () {
    return {
      rules,
      modalLoading: false,
      unitData: {
        unitName: '',
        creditCode: '',
      }
    }
  },
  computed: {
    getTitle () {
      return this.unitData.id ? '添加单位信息' : '编辑单位信息'
    }
  },
  created () {
  },
  methods: {
    async onLoad (id) {
      let that = this
      that.reset()
      if (id) {
        let res = await GetUnit(id)
        if (res.result) {
          that.unitData = res.result
        }
      }
    },
    reset () {
      this.unitData = {
        unitName: '',
        creditCode: '',
      }
    },
    onSave () {
      const that = this
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        const data = { ...that.unitData }
        let res
        that.modalLoading = true
        if (data.id) {
          res = await EditUnit(data)
        } else {
          res = await AddUnit(data)
        }
        that.modalLoading = false
        if (200 !== res.code) {
          that.$message.error(res.msg)
          return
        }
        that.$message.success('操作成功！！！')
        that.$emit('success')
      })

    },
  }
}
</script>

<style scoped>

</style>
